var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.breadcrumbs),function(item,n){return _c('li',{key:n},[(item.path)?_c('router-link',{attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.label || _vm.$t(`routes.${item.name}`))+" ")]):_c('a',[_vm._v(_vm._s(item.label || _vm.$t(`routes.${item.name}`)))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }